import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { ProfileService } from 'core/services';

export const ProfileGuard: CanActivateFn = (route, state) => {
  // return inject(PermissionsService).canActivate(inject(UserToken), route. params['id']);
  return inject(ProfileService).canActivate(route, state);
};
